import React from 'react'
import styled from '../../theme'
import { useTranslation } from 'react-i18next'
import { is } from '../../components/MediaQuery'
import { ChevronRight } from '@material-ui/icons'
import { useDispatch, useSelector } from 'react-redux'
import { getPriceDiff } from '../../reducers/price/selectors/price'
import { PriceConfigurationActions } from '../../reducers/price/actionNames'

export enum PriceSettingsTab {
  None = 0,
  Price,
  Availability,
  Fee,
  Tax,
  Accommodation,
  Currency,
}

const Wrapper = styled.div`
  display: flex;
  padding: 40px;
  flex-direction: column;
  border-right: 1px solid #e5e5e5;
  height: 100%;
  max-width: 300px;
  min-width: 266px;
@media (max-width: ${(theme) => theme.theme.breakpoints.tablet}) {
    padding: 40px;
    border-right: none;
    max-width: 100%;
    min-width: 100%;
    color: #000;
    background: #FFF;
    margin-top: 20px;
    font-family: Montserrat ,sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.028px;
  }
`

function PriceSettingsNavigator({
  active,
  onNavigation,
}: IPriceSettingsNavigator) {
  const { t } = useTranslation()
  const diff = useSelector(getPriceDiff)
  const dispatch = useDispatch()
  const isDesktop = is.desktop()

  const onNavigationClick = (tab: PriceSettingsTab) => () => {
    if(diff && isDesktop){
      dispatch({type: PriceConfigurationActions.CloseModal, payload: true, action: `/price/tab/${tab}`})
    } else {
      onNavigation && onNavigation(tab)()
    }
  }



  return (
    <Wrapper isDesktop={isDesktop}>
      <NavigationItem
        index={0}
        label={t('OUT_25_navi_bar_prices')}
        onClick={onNavigationClick(PriceSettingsTab.Price)}
        active={active === PriceSettingsTab.Price}
      />
      <NavigationItem
        index={1}
        label={t('OUT_25_navi_bar_availability')}
        onClick={onNavigationClick(PriceSettingsTab.Availability)}
        active={active === PriceSettingsTab.Availability}
      />
      <NavigationItem
        index={2}
        label={t('BED_11813_commission')}
        onClick={onNavigationClick(PriceSettingsTab.Fee)}
        active={active === PriceSettingsTab.Fee}
      />
      <NavigationItem
        index={3}
        label={t('BED_11804_local_tax')}
        onClick={onNavigationClick(PriceSettingsTab.Tax)}
        active={active === PriceSettingsTab.Tax}
      />
      <NavigationItem
        index={4}
        label={t('BED_11813_meals')}
        onClick={onNavigationClick(PriceSettingsTab.Accommodation)}
        active={active === PriceSettingsTab.Accommodation}
      />
      <NavigationItem
        index={5}
        label={t('profile_currency')}
        onClick={onNavigationClick(PriceSettingsTab.Currency)}
        active={active === PriceSettingsTab.Currency}
      />
    </Wrapper>
  )
}

const NavigationWrapper = styled.div<{ active?: boolean; isDesktop?: boolean; index?:number }>`
    border-radius: 6px;
    margin-bottom: 15px;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding: 12px 30px;
    width: 100%;
    
    
    background: ${props => (props.active && props.isDesktop ? '#E5F6EC' : '#fff')};
    color: ${props => (props.active && props.isDesktop ? '#00A541' : '#858585')};

    &:hover {
        cursor: pointer;
        background: #e5f6ec;
        color: #00a541;
    }

    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
        color: #000;
        border-bottom: ${props => props.index === 5? 'none':'1px solid #EFEFEF'};
        font-family: Montserrat, sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: 0.028px;
        padding: ${props => props.index === 0? '0':'20px'} 0 30px;

        &:hover {
            cursor: pointer;
            background: unset;
            color: #000;
        }
    }
`

function NavigationItem({ active, label, onClick, index }: INavigationItem) {
  const { t } = useTranslation()

  const isDesktop = is.desktop()

  return (
    <NavigationWrapper index={index} isDesktop={isDesktop} active={isDesktop && active} onClick={onClick}>
      {t(label)}
      {!isDesktop && <div style={{float: 'right'}}><ChevronRight/></div>}
    </NavigationWrapper>
  )
}



export interface INavigationItem {
  active: boolean
  label: string
  onClick: () => void
  index: number
}

export interface IPriceSettingsNavigator {
  active: PriceSettingsTab
  onNavigation?: (tab: PriceSettingsTab) => () => void
}

export default PriceSettingsNavigator
